import { useContext } from 'react';
import { AppContext } from '../App';
import { Avatar } from 'ds-form';

const SessionInfo = () => {

    const user  = useContext(AppContext);
    return ( 
        (user && (
        <div style={{ display: "flex", alignItems: "center" }}>
            <Avatar user={{value: user.login, label: user.lastName}}/>
        </div>
        ))
    );
};

export default SessionInfo;
